export const selectTransaction = state => state.transaction.transaction;
export const selectQuote = state => selectTransaction(state).quote;
export const selectError = state => state.transaction.error;
export const selectIsFetching = state => state.transaction.isFetching;
export const selectClientCountry = state => state.transaction.clientCountry;
